/**
 * Moving a row up or down a list.
 *
 * It is its own function because it is the operation ids get lost in. Rebuilding a list by
 * mapping over indexes is how a question ends up with a fresh id and its published answers stop
 * counting, so the moved items here are the same objects, in a different order, always.
 */
export function moveInList<T>(items: readonly T[], index: number, delta: number): readonly T[] {
  const target = index + delta;
  if (index < 0 || index >= items.length) return items;
  if (target < 0 || target >= items.length) return items;

  const next = [...items];
  const moved = next[index];
  const displaced = next[target];
  if (moved === undefined || displaced === undefined) return items;
  next[target] = moved;
  next[index] = displaced;
  return next;
}
